import React from "react";
import { useParams, useLocation } from "react-router-dom";
import Recipe from "./Recipe";
import Recipedetails from "./Recipedetails";

export default function MealPlanRouter() {
  const { any } = useParams();
  const location = useLocation();

  const currentUrl = location.pathname + location.search;

  // Just check if 'recId=' exists in the URL
  const hasRecId = currentUrl.includes("recId=");

  console.log("MealPlanRouter currentUrl:", currentUrl);
  console.log("Contains recId?:", hasRecId);

  if (hasRecId) {
    return <Recipedetails />;
  } else {
    return <Recipe />;
  }
}
